import {
  ALLOCATION_MAIL_STAKEHOLDERS,
  ALLOCATION_MAIL_STAKEHOLDERS_VERTICALS,
  ALLOCATION_MAIL_STAKEHOLDERS_RESOURCE_DETAILS,
  ALLOCATION_MAIL_STAKEHOLDERS_EMPLOYEE_DETAILS,
} from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

/**
 * Fetch list of allocation mail stakeholders
 */
export const getAllocationStakeholdersList = () => ({
  url: `${ALLOCATION_MAIL_STAKEHOLDERS}?cb=${Date.now()}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

/**
 * Add a new allocation mail stakeholder
 */
export const addAllocationStakeholder = (data) => ({
  url: ALLOCATION_MAIL_STAKEHOLDERS,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: data,
  service: serviceName.MASTER_MS,
});

/**
 * Edit an existing allocation mail stakeholder
 */
export const editAllocationStakeholder = (id, data) => ({
  url: `${ALLOCATION_MAIL_STAKEHOLDERS}/${id}`,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: data,
  service: serviceName.MASTER_MS,
});

/**
 * Toggle active/inactive status of an allocation mail stakeholder
 */
export const toggleAllocationStakeholderStatus = (id, status) => {
  const resolvedStatus = typeof status === 'object' && status !== null
    ? (status.status ?? status.is_active ?? status.isActive)
    : status;

  return {
    url: `${ALLOCATION_MAIL_STAKEHOLDERS}/${id}/toggle-status`,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: {
      status: resolvedStatus ? 1 : 0,
      is_active: resolvedStatus ? 1 : 0,
    },
    service: serviceName.MASTER_MS,
  };
};


/**
 * Delete an allocation mail stakeholder
 */
export const deleteAllocationStakeholder = (id) => ({
  url: `${ALLOCATION_MAIL_STAKEHOLDERS}/${id}`,
  method: 'delete',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});


/**
 * Fetch vertical dropdown options
 */
export const getVerticalDropdownOptions = () => ({
  url: ALLOCATION_MAIL_STAKEHOLDERS_VERTICALS,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

/**
 * Fetch roles dropdown options
 */
export const getRolesDropdownOptions = () => ({
  url: ALLOCATION_MAIL_STAKEHOLDERS_RESOURCE_DETAILS,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

/**
 * Fetch employees dropdown options
 */
export const getEmployeesDropdownOptions = () => ({
  url: ALLOCATION_MAIL_STAKEHOLDERS_EMPLOYEE_DETAILS,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});
